$(document).ready(function () {
    if (!$('#footer-container').length) {
        return;
    }

    $(".accordion-single-wrapper").on('click', function () {
        $(this).toggleClass("show")
    })

    $('#mc-embedded-subscribe-form #newsletter-agree').change(function () {
        if ($('#mc-embedded-subscribe-form button').is(':disabled')) {
            $('#mc-embedded-subscribe-form button').prop('disabled', false)
        } else {
            $('#mc-embedded-subscribe-form button').prop('disabled', true)
        }
    })

    $('#mc-embedded-subscribe-form').on('submit', function (e) {
        if (!$('#mc-embedded-subscribe-form #newsletter-agree').is(':checked')) {
            $('#mc-embedded-subscribe-form .newsletter-agree-wrapper label').css('color', 'red')
        }
    })
    // select the target node
    var target = document.getElementById('mce-success-response');

// create an observer instance
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (target.innerHTML === "Thank you for subscribing!") {
                target.innerHTML = footerText;
            }
        });
    });

// configuration of the observer:
    var config = { attributes: true, childList: true, characterData: true };

// pass in the target node, as well as the observer options
    observer.observe(target, config);
})
